module.exports = __webpack_public_path__ + "static/media/item_2_9.409c4829.png";